import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL || 'http://localhost:4000/api',
});

// Request interceptor to add token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('adminToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for error handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('adminToken');
            localStorage.removeItem('adminUser');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export const getWilayas = async (keyword) => {
    try {
        const response = await api.get('/location/get-wilayas', {
            params: { keyword }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching wilayas:', error);
        throw error;
    }
};

export const getCommunes = async (keyword) => {
    try {
        const response = await api.get('/location/get-communes', {
            params: { keyword }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching communes:', error);
        throw error;
    }
};

export const getCommunesOfWilaya = async (wilaya) => {
    try {
        const response = await api.get('/location/get-communes-of-wilaya', {
            params: { wilaya }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching communes of wilaya:', error);
        throw error;
    }
};

export default api;
